// src/components/Header.jsx
import React from "react";
import "./Header.css";
import {useLanguage} from "../context/LanguageContext";
import earthImg from "../assets/img/earth.png";
import uaeLangImg from "../assets/img/uae_lang.png";

const Header = () => {
    const {language, setLanguage} = useLanguage();
    const uaeLangImg = require("../assets/img/uae_lang.png");
    const etisalatLogo = require("../assets/img/etisalat_logo_new.png");
    const etisalatLogoAr = require("../assets/img/etisalat_logo_new_ar.png");

    const switchLanguage = (lang) => {
        setLanguage(lang);
        const url = new URL(window.location.href);
        url.searchParams.set('lang', lang);
        window.history.pushState({}, '', url);    };

    return (
        <div className="header header-wrapper">
            {/*<div className={`inner-header ${language === 'ar' ? 'rtl' : 'ltr'}`}>*/}
            <div className="inner-header">

                {language === 'en' ? (
                    <div className="lang-en">
                        <div className="flex-center-align">
                            <div className="language-selector"
                                 onClick={() => switchLanguage(language === 'en' ? 'ar' : 'en')}>
                                <img src={language === 'en' ? uaeLangImg : earthImg} className="language-flag"
                                     alt="Language Flag"/>
                                <a className="cursor:pointer">
                                <span className="text-arabic">
                                    {language === 'en' ? (<span className="h4text-ar">عربي</span>) : (
                                        <span>English</span>)}
                                </span>
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="lang-ar">
                        <div className="flex-center-align">
                            <div className="language-selector"
                                 onClick={() => switchLanguage(language === 'en' ? 'ar' : 'en')}>
                                <img src={language === 'en' ? uaeLangImg : earthImg} className="language-flag"
                                     alt="Language Flag"/>
                                <a className="cursor:pointer">
                                <span className="text-arabic">
                                    {language === 'en' ? (<span className="h4text-ar">عربي</span>) : (
                                        <span>English</span>)}
                                </span>
                                </a>
                            </div>
                        </div>
                    </div>
                )}

                {language === 'en' ? (
                        <div className="logo-en">
                            <div className="flex-center-align">
                                <div className="image-wrap">
                                    <img className="etisalat-logo" src={etisalatLogo} alt="Etisalat Logo"/>
                                    <span>                {language === 'en' ? (<h4>Mundi Word</h4>) : (
                                        <h4 className="h4Num-ar">Mundi Word</h4>)}
                            </span>

                                </div>
                            </div>
                        </div>
                ) :
                    (
                        <div className="logo-ar">
                            <div className="flex-center-align">
                                <div className="image-wrap">
                                    <img className="etisalat-logo" src={etisalatLogoAr} alt="Etisalat Logo"/>
                                    <span>                {language === 'en' ? (<h4>Mundi Word</h4>) : (
                                        <h4 className="h4Num-ar">Mundi Word</h4>)}
                            </span>

                                </div>
                            </div>
                        </div>
                    )}

            </div>
        </div>
    );
};

export default Header;
